
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreateProjectHouseSideDtoFormGroup() {
return new FormGroup({
    projectId: new FormControl<number | undefined>(undefined, [Validators.required]),
    sideIndex: new FormControl<number | undefined>(undefined, [Validators.required]),
    sideLabel: new FormControl<string | undefined>(undefined),
    minHeightInM: new FormControl<number | undefined>(undefined),
    maxHeightInM: new FormControl<number | undefined>(undefined),
    widthInM: new FormControl<number | undefined>(undefined, [Validators.required]),
    hasDormers: new FormControl<boolean | undefined>(undefined),
    hasSolarPanels: new FormControl<boolean | undefined>(false),
    dormerLengthInM: new FormControl<number | undefined>(undefined),
    towerNumber: new FormControl<number | undefined>(undefined),
    hasRoofOverhang: new FormControl<boolean | undefined>(undefined),
    calculatedAreaInSqm: new FormControl<number | undefined>(undefined),
    baseAreaInSqm: new FormControl<number | undefined>(undefined),
    notes: new FormControl<string | undefined>(undefined),
    active: new FormControl<boolean | undefined>(undefined),
})
;
}
      